import React from 'react';
import Spinner from 'components/Spinner';
import magGlassIcon from 'assets/images/icons/magnifying-glass.svg';
import styles from './SearchCard.module.scss';

interface SingleInputSearchProps {
  loading: boolean;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
}

const SingleInputSearch: React.FC<SingleInputSearchProps> = ({ loading, onSubmit }) => (
  <form noValidate name="vehicleRegSearch" onSubmit={onSubmit}>
    <div className={styles.searchContainer}>
      <input
        className={styles.input}
        type="text"
        name="regNo"
        placeholder="Enter vehicle registration"
        required
      />
      <button
        type="submit"
        className={styles.searchIcon}
        aria-label="Search vehicle registration"
      >
        {loading ? <Spinner buttonSpinner /> : <img src={magGlassIcon} alt="Search" />}
      </button>
    </div>
  </form>
);

export default SingleInputSearch;
